import {createAsyncThunk} from "@reduxjs/toolkit";
import {AxiosResponse} from "axios";
import instance from "@/config/axios";
import { serializeQueryParam } from '@/utils';

export const getRoleList = createAsyncThunk('role/getRoleList',
  async ({search, size, sort, page}: UserListQuery) => {
    const url = `v1/roles${serializeQueryParam({
      search,
      sortBy: sort,
      size,
      page
    })}`
    const response: AxiosResponse<RoleState> = await instance.get(url)
    return response.data
  })

export const createRole = createAsyncThunk('role/createRole',
  async (data: RolePayload) => {
    const response: AxiosResponse<RoleState> = await instance.post('v1/roles', data)
    return response.data
  })

export const editRole = createAsyncThunk('role/editRole',
  async ({ id, data }: any) => {
    const response: AxiosResponse<RoleState> = await instance.put(`v1/roles/${id}`, data)
    return response.data
  })
